import { SdNotification } from '@solid-design-system/components/dist-versioned';
import { firstValueFrom, Observable } from 'rxjs';
import { HashMap, translate } from '@ngneat/transloco';

export async function displayNotification(
  message: string | Observable<string> | null,
  variant: SdNotification['variant'],
  options:
    | {
        closable?: boolean;
        durationInMs?: number;
      }
    | undefined = { closable: true, durationInMs: 10000 }
): Promise<void> {
  if (message === null) {
    return;
  }

  if (typeof message !== 'string') {
    message = await firstValueFrom(message);
  }

  const notification: SdNotification = document.createElement('sd-6-17-1-notification') as SdNotification;
  notification.textContent = message;
  notification.variant = variant;

  if (options) {
    if (options.closable) {
      notification.closable = true;
    }

    if (options.durationInMs !== undefined) {
      notification.duration = options.durationInMs;
      notification.durationIndicator = true;
    }
  }

  notification.toast();
}

const SUCCESS_DURATION_MS = 3000;
const DEFAULT_DURATION_MS = 5000;

/** Shows a translated success message for 3 seconds. */
function success(key: string, params?: HashMap): void {
  void NotificationUtils.displayNotification(translate(key, params), 'success', {
    closable: true,
    durationInMs: SUCCESS_DURATION_MS,
  });
}

function info(key: string, params?: HashMap): void {
  void NotificationUtils.displayNotification(translate(key, params), 'info', {
    closable: true,
    durationInMs: DEFAULT_DURATION_MS,
  });
}

function error(key: string, cause?: unknown, params?: HashMap): void {
  const errorDetail = (cause as { message?: string } | undefined)?.message ?? '';
  void NotificationUtils.displayNotification(translate(key, { ...params, errorDetail }), 'error', {
    closable: true,
    durationInMs: DEFAULT_DURATION_MS,
  });
}

export const NotificationUtils = {
  displayNotification,
  success,
  info,
  error,
};
